import currency from './currency'
import pluralize from './pluralize'

export {
  currency,
  pluralize
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-filters/src/other/index.js
// module id = qvdn
// module chunks = 34